import React, { Component } from "react";
import { connect } from "react-redux";
import { openMediaViewer } from "Actions";

import MediaComponent from "./MediaComponent";

export class MediaContainer extends Component {
  handleOpenMediaReveal = e => {
    const { openMediaViewer, media } = this.props;

    openMediaViewer({
      medias: [media],
      isOpen: true,
      currentMedia: media
    });
  };
  render() {
    const { community, media, language } = this.props;

    return (
      <MediaComponent
        media={media}
        community={community}
        language={language}
        openMediaReveal={this.handleOpenMediaReveal}
      />
    );
  }
}

// Connected Component
const mapStateToProps = state => ({
  language: state.params.lng
});

const mapDispatchToProps = dispatch => ({
  openMediaViewer: viewer => dispatch(openMediaViewer(viewer))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MediaContainer);



// WEBPACK FOOTER //
// ./src/components/Community/NewCommunity/Media/MediaContainer.js